export const maximize = {
  name: "maximize" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M13.635 3.828c0-.483.392-.875.875-.875h5.782a.75.75 0 0 1 .75.75v5.782a.875.875 0 0 1-1.75 0V5.941l-4.673 4.673a.875.875 0 1 1-1.238-1.237l4.674-4.674H14.51a.875.875 0 0 1-.875-.875ZM10.36 20.169a.875.875 0 0 1-.875.875H3.703a.75.75 0 0 1-.75-.75v-5.782a.875.875 0 1 1 1.75 0v3.544l4.674-4.673a.875.875 0 1 1 1.237 1.237l-4.673 4.674h3.544c.484 0 .875.392.875.875Z" clip-rule="evenodd"/></svg>`,
  keywords: ["maximize"],
  category: "action" as const,
};
